import type { ReactNode } from "react";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";

// PostHog is used ONLY for feature-flag management — no behavioral event capture,
// no pageviews, no session recording. We do identify the logged-in user (see
// useFeatureFlagIdentity in src/hooks/useFeatureFlags.ts) purely so flags can
// target users/labels. All direct PostHog SDK access is confined to this module
// and that hook so the provider can be swapped in one place.
posthog.init(import.meta.env.VITE_POSTHOG_PROJECT_TOKEN ?? "", {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  disable_session_recording: true,
  // Person profiles are created only for identified users (logged-in), never for
  // anonymous visitors.
  person_profiles: "identified_only",
});

export function FeatureFlagProvider({ children }: { children: ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
